import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getSessionItem, removeSessionItem } from './utils';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private router: Router, private http: HttpClient) {}

  validateToken(): boolean {
    const token = getSessionItem('sessionToken');
    if (!token) {
      this.clearSession();
      return false;
    }

    try {
      // const payload = JSON.parse(atob(token.split('.')[1]));
      // const isExpired = payload.exp * 1000 < Date.now();
      
      // if (isExpired) {
      //   this.clearSession();
      //   return false;
      // }

      // Validate with Azure in background
      this.validateWithAzure(token).subscribe();
      return true;
    } catch {
      this.clearSession();
      return false;
    }
  }

  private validateWithAzure(token: string): Observable<boolean> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    
    return this.http.get('https://graph.microsoft.com/v1.0/me', { headers }).pipe(
      map(() => true),
      catchError(() => {
        this.clearSession();
        return of(false);
      })
    );
  }

  clearSession(): void {
    removeSessionItem('accessToken');
    removeSessionItem('userAccount');
    this.router.navigate(['/signin']);
  }
}
